import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";
// import { SocketContext } from "../../context/Socket/SocketContext";
import n8n from "../../assets/n8n.png";
import dialogflow from "../../assets/dialogflow.png";
import webhooks from "../../assets/webhook.png";
import typebot from "../../assets/typebot.jpg";
import flowbuilder from "../../assets/flowbuilders.png";

import { makeStyles } from "@material-ui/core/styles";

import {
  Avatar,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Switch,
  FormControlLabel,
  Chip,
  Box,
} from "@material-ui/core";

import { DeleteOutline, Edit, Add as AddIcon } from "@material-ui/icons";

import SearchIcon from "@material-ui/icons/Search";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import IntegrationModal from "../../components/QueueIntegrationModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";

const reducer = (state, action) => {
  if (action.type === "LOAD_INTEGRATIONS") {
    const queueIntegration = action.payload;
    const newIntegrations = [];

    queueIntegration.forEach((integration) => {
      const integrationIndex = state.findIndex((u) => u.id === integration.id);
      if (integrationIndex !== -1) {
        state[integrationIndex] = integration;
      } else {
        newIntegrations.push(integration);
      }
    });

    return [...state, ...newIntegrations];
  }

  if (action.type === "UPDATE_INTEGRATIONS") {
    const queueIntegration = action.payload;
    const integrationIndex = state.findIndex(
      (u) => u.id === queueIntegration.id
    );

    if (integrationIndex !== -1) {
      state[integrationIndex] = queueIntegration;
      return [...state];
    } else {
      return [queueIntegration, ...state];
    }
  }

  if (action.type === "DELETE_INTEGRATION") {
    const integrationId = action.payload;

    const integrationIndex = state.findIndex((u) => u.id === integrationId);
    if (integrationIndex !== -1) {
      state.splice(integrationIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  avatar: {
    width: "140px",
    height: "40px",
    borderRadius: 4,
  },
}));

const QueueIntegration = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [queueIntegration, dispatch] = useReducer(reducer, []);

  // Asaas (cobranças via WhatsApp)
  const [asaasConfigs, setAsaasConfigs] = useState([]);
  const [asaasLoading, setAsaasLoading] = useState(false);
  const [asaasModalOpen, setAsaasModalOpen] = useState(false);
  const [editingAsaasId, setEditingAsaasId] = useState(null);
  const [asaasName, setAsaasName] = useState("");
  const [asaasToken, setAsaasToken] = useState("");
  const [asaasEnvironment, setAsaasEnvironment] = useState("production");
  const [asaasActive, setAsaasActive] = useState(true);
  const [deletingAsaasConfig, setDeletingAsaasConfig] = useState(null);
  const [asaasConfirmModalOpen, setAsaasConfirmModalOpen] = useState(false);
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const { getPlanCompany } = usePlans();
  const companyId = user.companyId;
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useIntegrations) {
        toast.error(
          "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando."
        );
        setTimeout(() => {
          history.push(`/`);
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchIntegrations = async () => {
        try {
          const { data } = await api.get("/queueIntegration/", {
            params: { searchParam, pageNumber },
          });
          dispatch({
            type: "LOAD_INTEGRATIONS",
            payload: data.queueIntegrations,
          });
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchIntegrations();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    const onQueueEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({
          type: "UPDATE_INTEGRATIONS",
          payload: data.queueIntegration,
        });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_INTEGRATION", payload: +data.integrationId });
      }
    };

    socket.on(`company-${companyId}-queueIntegration`, onQueueEvent);
    return () => {
      socket.off(`company-${companyId}-queueIntegration`, onQueueEvent);
    };
  }, []);

  const fetchAsaasConfigs = async () => {
    setAsaasLoading(true);
    try {
      const { data } = await api.get("/asaas/configs");
      setAsaasConfigs(data);
    } catch (err) {
      toastError(err);
    } finally {
      setAsaasLoading(false);
    }
  };

  useEffect(() => {
    fetchAsaasConfigs();
  }, []);

  const handleOpenAsaasModal = () => {
    setEditingAsaasId(null);
    setAsaasName("");
    setAsaasToken("");
    setAsaasEnvironment("production");
    setAsaasActive(true);
    setAsaasModalOpen(true);
  };

  const handleEditAsaasConfig = (config) => {
    setEditingAsaasId(config.id);
    setAsaasName(config.name);
    setAsaasToken(""); // não retorna o token salvo por segurança
    setAsaasEnvironment(config.environment);
    setAsaasActive(config.active);
    setAsaasModalOpen(true);
  };

  const handleCloseAsaasModal = () => {
    setAsaasModalOpen(false);
  };

  const handleSaveAsaasConfig = async () => {
    if (!asaasName.trim()) {
      toast.error("Informe um nome pra identificar essa credencial");
      return;
    }
    if (!editingAsaasId && !asaasToken.trim()) {
      toast.error("Informe o token de API da Asaas");
      return;
    }

    try {
      if (editingAsaasId) {
        await api.put(`/asaas/configs/${editingAsaasId}`, {
          name: asaasName,
          token: asaasToken || undefined,
          environment: asaasEnvironment,
          active: asaasActive,
        });
        toast.success("Credencial Asaas atualizada");
      } else {
        await api.post("/asaas/configs", {
          name: asaasName,
          token: asaasToken,
          environment: asaasEnvironment,
        });
        toast.success("Credencial Asaas cadastrada");
      }
      setAsaasModalOpen(false);
      fetchAsaasConfigs();
    } catch (err) {
      toastError(err);
    }
  };

  const handleDeleteAsaasConfig = async (id) => {
    try {
      await api.delete(`/asaas/configs/${id}`);
      toast.success("Credencial Asaas removida");
      fetchAsaasConfigs();
    } catch (err) {
      toastError(err);
    }
    setDeletingAsaasConfig(null);
  };

  const handleOpenUserModal = () => {
    setSelectedIntegration(null);
    setUserModalOpen(true);
  };

  const handleCloseIntegrationModal = () => {
    setSelectedIntegration(null);
    setUserModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditIntegration = (queueIntegration) => {
    setSelectedIntegration(queueIntegration);
    setUserModalOpen(true);
  };

  const handleDeleteIntegration = async (integrationId) => {
    try {
      await api.delete(`/queueIntegration/${integrationId}`);
      toast.success(i18n.t("queueIntegration.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingUser(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={
          deletingUser &&
          `${i18n.t("queueIntegration.confirmationModal.deleteTitle")} ${
            deletingUser.name
          }?`
        }
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteIntegration(deletingUser.id)}
      >
        {i18n.t("queueIntegration.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <IntegrationModal
        open={userModalOpen}
        onClose={handleCloseIntegrationModal}
        aria-labelledby="form-dialog-title"
        integrationId={selectedIntegration && selectedIntegration.id}
      />
      {user.profile === "user" ? (
        <ForbiddenPage />
      ) : (
        <>
          <MainHeader>
            <Title>
              {i18n.t("queueIntegration.title")} ({queueIntegration.length})
            </Title>
            <MainHeaderButtonsWrapper>
              <TextField
                placeholder={i18n.t("queueIntegration.searchPlaceholder")}
                type="search"
                value={searchParam}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="secondary" />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenUserModal}
              >
                {i18n.t("queueIntegration.buttons.add")}
              </Button>
            </MainHeaderButtonsWrapper>
          </MainHeader>
          <Paper
            className={classes.mainPaper}
            variant="outlined"
            onScroll={handleScroll}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox"></TableCell>
                  <TableCell align="center">
                    {i18n.t("queueIntegration.table.id")}
                  </TableCell>
                  <TableCell align="center">
                    {i18n.t("queueIntegration.table.name")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <>
                  {queueIntegration.map((integration) => (
                    <TableRow key={integration.id}>
                      <TableCell>
                        {integration.type === "dialogflow" && (
                          <Avatar src={dialogflow} className={classes.avatar} />
                        )}
                        {integration.type === "n8n" && (
                          <Avatar src={n8n} className={classes.avatar} />
                        )}
                        {integration.type === "webhook" && (
                          <Avatar src={webhooks} className={classes.avatar} />
                        )}
                        {integration.type === "typebot" && (
                          <Avatar src={typebot} className={classes.avatar} />
                        )}
                        {integration.type === "flowbuilder" && (
                          <Avatar
                            src={flowbuilder}
                            className={classes.avatar}
                          />
                        )}
                      </TableCell>

                      <TableCell align="center">{integration.id}</TableCell>
                      <TableCell align="center">{integration.name}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          onClick={() => handleEditIntegration(integration)}
                        >
                          <Edit color="secondary" />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            setConfirmModalOpen(true);
                            setDeletingUser(integration);
                          }}
                        >
                          <DeleteOutline color="secondary" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {loading && <TableRowSkeleton columns={7} />}
                </>
              </TableBody>
            </Table>
          </Paper>

          <ConfirmationModal
            title={
              deletingAsaasConfig &&
              `Excluir a credencial "${deletingAsaasConfig.name}"?`
            }
            open={asaasConfirmModalOpen}
            onClose={setAsaasConfirmModalOpen}
            onConfirm={() => handleDeleteAsaasConfig(deletingAsaasConfig.id)}
          >
            Os boletos/cobranças enviados usando esse token vão parar de funcionar.
          </ConfirmationModal>

          <Dialog open={asaasModalOpen} onClose={handleCloseAsaasModal} maxWidth="sm" fullWidth>
            <DialogTitle>
              {editingAsaasId ? "Editar credencial Asaas" : "Nova credencial Asaas"}
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2} style={{ marginTop: 4 }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome (pra identificar essa credencial)"
                    value={asaasName}
                    onChange={(e) => setAsaasName(e.target.value)}
                    placeholder="Ex: Conta principal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={editingAsaasId ? "Novo token (deixe em branco pra manter o atual)" : "Token de API da Asaas"}
                    value={asaasToken}
                    onChange={(e) => setAsaasToken(e.target.value)}
                    type="password"
                    placeholder="$aact_..."
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Ambiente</InputLabel>
                    <Select
                      value={asaasEnvironment}
                      onChange={(e) => setAsaasEnvironment(e.target.value)}
                    >
                      <MenuItem value="production">Produção</MenuItem>
                      <MenuItem value="sandbox">Sandbox (testes)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={asaasActive}
                        onChange={(e) => setAsaasActive(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Ativa"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseAsaasModal}>Cancelar</Button>
              <Button onClick={handleSaveAsaasConfig} color="primary" variant="contained">
                Salvar
              </Button>
            </DialogActions>
          </Dialog>

          <MainHeader>
            <Title>Asaas — Cobranças via WhatsApp ({asaasConfigs.length})</Title>
            <MainHeaderButtonsWrapper>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleOpenAsaasModal}
              >
                Nova credencial
              </Button>
            </MainHeaderButtonsWrapper>
          </MainHeader>
          <Paper className={classes.mainPaper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell align="center">Ambiente</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {asaasConfigs.map((config) => (
                  <TableRow key={config.id}>
                    <TableCell>{config.name}</TableCell>
                    <TableCell align="center">
                      {config.environment === "sandbox" ? "Sandbox" : "Produção"}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        size="small"
                        label={config.active ? "Ativa" : "Inativa"}
                        color={config.active ? "primary" : "default"}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        size="small"
                        onClick={() => handleEditAsaasConfig(config)}
                      >
                        <Edit color="secondary" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setAsaasConfirmModalOpen(true);
                          setDeletingAsaasConfig(config);
                        }}
                      >
                        <DeleteOutline color="secondary" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {asaasLoading && <TableRowSkeleton columns={4} />}
                {!asaasLoading && asaasConfigs.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      Nenhuma credencial cadastrada ainda.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
    </MainContainer>
  );
};

export default QueueIntegration;
